import { useEffect, useState, useLayoutEffect } from "react";

import Banner from "component/banner/Banner";
import DisplayType from "utils/displayType";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import { getMembers } from "lib/latticeApi";
import { TeamContainer, TeamStaffContainer } from "./styles";
import Footer from "../../component/footer/Footer";
import TeamSectionDepth1, {
  TeamSectionProps,
} from "./organism/TeamSectionDepth1";
import teamBanner from "../../assets/team_banner.png";
import teamBanner1920 from "../../assets/team_banner_1920.png";
import teamBanner2048 from "../../assets/team_banner_2048.png";

const Team = () => {
  const mode = DisplayType();
  const { t } = useLanguage();
  const [structureData, setStructureData] = useState<TeamSectionProps[]>([]);

  const getHpStructure = async () => {
    try {
      const { teams } = await getMembers();

      const result: TeamSectionProps[] = teams.map((team) => ({
        teamId: team.id,
        name: team.name,
        description: team.description,
        members: team.members,
      }));
      setStructureData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useLayoutEffect(() => {
    updateTitle(t("team", "pageTitle"));
  }, [t]);

  useEffect(() => {
    getHpStructure();
  }, []);

  return (
    <TeamContainer>
      <Banner
        bannerImg={teamBanner}
        bannerImg1920={teamBanner1920}
        bannerImg2048={teamBanner2048}
        mode={mode}
        style={{ backgroundPosition: "center", backgroundPositionY: -150 }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: mode === "Mobile" ? "center" : "flex-start",
            paddingTop: mode === "Mobile" ? 70 : 0,
          }}
        >
          <div
            className={`${
              mode === "Mobile" ? "font-title-en" : "font-title-en"
            }`}
            style={{ color: "var(--white)" }}
          >
            TEAM
          </div>
          <div
            className={mode === "Mobile" ? "font-body3" : "font-body1"}
            style={{ color: "var(--white)", marginTop: 24 }}
          >
            {renderText(t("team", "bannerDescription"))}
          </div>
        </div>
      </Banner>
      <TeamStaffContainer className="limit__body">
        {structureData.map((item) => {
          return <TeamSectionDepth1 key={item.teamId} item={item} />;
        })}
      </TeamStaffContainer>
      <Footer />
    </TeamContainer>
  );
};
export default Team;
